module.exports = __webpack_public_path__ + "img/Imagotipo.65d8706d.svg";